export async function getKYCProfile(walletAddress, providers = ["blockpass"], signal) {
    const url = `${process.env.REACT_APP_KYC_API_URL}/v1.0/profile?walletAddress=${walletAddress}&providers=${providers.join(",")}`

    try {
        const res = await fetch(url, { signal })
        const profile = await res.json();

        if(res.ok && profile?.status === "APPROVED") {
            return true;
        }
    
        return false;
    } catch(e) {
        console.log(e)
        return false;
    }
}

/**
 * {
	"status": "NOT_FOUND",    if approved will be "APPROVED"
	"info": {
		"blockpassopencampus": {
			"status": "error",
			"message": "Resource not Found",
			"code": 404,
			"data": {
				"msg": "Resource not Found",
				"code": 404,
				"extra": {}
			}
		}
	}
}
 */